import { Trans } from '@lingui/react/macro'
import React, { FC } from 'react'
import { styled } from 'styled-components'

export enum ValueBreakdownDisplayType {
  Area,
  Percent,
}

export const ValueBreakdownDisplayTypeSelector: FC<{
  canDisplayArea: boolean
  valueDisplayType: ValueBreakdownDisplayType
  setValueDisplayType: (newType: ValueBreakdownDisplayType) => void
}> = (props) => {
  if (!props.canDisplayArea) {
    if (props.valueDisplayType === ValueBreakdownDisplayType.Area) {
      props.setValueDisplayType(ValueBreakdownDisplayType.Percent)
    }
    return null
  }

  return (
    <OuterContainer>
      <ToggleContainer>
        <ToggleButton
          $active={props.valueDisplayType === ValueBreakdownDisplayType.Area}
          onClick={() =>
            props.setValueDisplayType(ValueBreakdownDisplayType.Area)
          }>
          <Trans>Area</Trans>
        </ToggleButton>
        <ToggleButton
          $active={props.valueDisplayType === ValueBreakdownDisplayType.Percent}
          onClick={() =>
            props.setValueDisplayType(ValueBreakdownDisplayType.Percent)
          }>
          <Trans>Percent</Trans>
        </ToggleButton>
      </ToggleContainer>
    </OuterContainer>
  )
}

const OuterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`

const ToggleContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  justify-content: center;
  padding-top: 0.5rem;
  width: 61.8%;
`

const ToggleButton = styled.button<{ $active: boolean }>`
  position: relative;
  background: transparent;
  border: 1px solid ${({ theme }) => theme.forecast.defaultText};
  color: ${({ theme }) => theme.forecast.defaultText};
  padding: 0.25rem 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
  opacity: ${({ $active }) => ($active ? 1 : 0.5)};

  &:hover {
    opacity: 0.8;
  }

  &:first-child {
    border-radius: 0.5rem 0 0 0.5rem;
  }

  &:last-child {
    border-radius: 0 0.5rem 0.5rem 0;
  }
`
